import React, { useEffect } from "react";
import Data from "../../dummy";

import { ToastContainer } from "react-toastify";

import { verifyEmail } from "../../../states/actions/fetchSignup";
import { useSelector, useDispatch } from "react-redux";
import useDocumentTitle from "../../../hooks/useDocumentTitle";
import LoadingScreen from "../../common/LoadingScreen";
import { useSearchParams, useLocation, useParams } from "react-router-dom";
import Text from "../../common/Text";
import ImageControl from "../../common/ImageControl";
import * as paths from "../../../constants/paths";
import { getStoredReferral } from "../../../hooks/useReferralLink";

const EmailVerify = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const dispatch = useDispatch();
  const data = useSelector((state) => state.fetchSignup.content);
  const isLoading = useSelector((state) => state.fetchSignup.isLoading);
  const isSiteSettingsLoading = useSelector(
    (state) => state.fetchSiteSettings.isLoading
  );
  const isFormProcessing = useSelector(
    (state) => state.fetchSignup.isFormProcessing
  );
  const { content } = data;

  const location = useParams();
  // console.log(location);

  useEffect(() => {
    // signup_by_referral_link is written at verification, not at signup, so
    // the referral has to be sent again here. Verifying by clicking the link
    // in the email reaches this route rather than the signup form, and used
    // to drop it.
    dispatch(
      verifyEmail({
        code: location.code,
        email: location.email,
        signupRef: getStoredReferral().ref,
      })
    );
  }, []);

  useDocumentTitle(data.page_title);
  return (
    <>
      {isLoading || isSiteSettingsLoading ? (
        <LoadingScreen />
      ) : (
        <>
          <ToastContainer />
          <section id="logon" className="register_form">
            <div className="contain">
              <div className="flex_row main_row row mobile_res_po">
                <div className="col col-lg-5">
                  <div className="in_col">
                    <form action="" method="POST">
                      <div className="log_blk">
                        <div className="txt heading_cstm_cstm">
                          <h2>Email Verification</h2>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
                <div className="col col-lg-5">
                  <div className="content text-center">
                    <h2 className="heading">
                      <Text string="Welcome!" />
                    </h2>
                    <p>
                      <Text string="Apply for Visa Sponsored Jobs from Global Organisations." />
                    </p>
                    <div className="register_img">
                      {/* <ImageControl folder="images" src="/images/ev.png" /> */}
                      <img
                        src={paths.SITE_BASE_URL + "/images/ev.png"}
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </>
      )}
    </>
  );
};

export default EmailVerify;
